import email from '../assets/email.png';
import email2 from '../assets/email2.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.svg';
import js from '../assets/js.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';
import jobin from '../assets/jobin.png'

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

import social1 from '../assets/social1.PNG'
import social2 from '../assets/social2.PNG'
import social3 from '../assets/social3.PNG'
import social4 from '../assets/social4.PNG'
import social5 from '../assets/social5.PNG'
import social6 from '../assets/social6.PNG'

import shopping1 from '../assets/shopping1.PNG'
import shopping2 from '../assets/shopping2.PNG'
import shopping3 from '../assets/shopping3.PNG'
import shopping4 from '../assets/shopping4.PNG'
import shopping5 from '../assets/shopping5.PNG'
import shopping6 from '../assets/shopping6.PNG'
import shopping7 from '../assets/shopping7.PNG'
import shopping8 from '../assets/shopping8.PNG'
import shopping9 from '../assets/shopping9.PNG'
import shopping10 from '../assets/shopping10.PNG'
import shopping11 from '../assets/shopping11.PNG'
import shopping12 from '../assets/shopping12.PNG'
import shopping13 from '../assets/shopping13.PNG'

import youtube1 from '../assets/youtube1.PNG'
import youtube2 from '../assets/youtube2.PNG'
import youtube3 from '../assets/youtube3.PNG'
import youtube4 from '../assets/youtube4.PNG'
import youtube5 from '../assets/youtube5.PNG'
import youtube6 from '../assets/youtube6.PNG'
import youtube7 from '../assets/youtube7.PNG'
import youtube8 from '../assets/youtube8.PNG'

import pizza1 from '../assets/pizza1.PNG'
import pizza2 from '../assets/pizza2.PNG'
import pizza3 from '../assets/pizza3.PNG'
import pizza4 from '../assets/pizza4.PNG'
import pizza5 from '../assets/pizza5.PNG'
import pizza6 from '../assets/pizza6.PNG'

import recipe1 from '../assets/recipe1.PNG'
import recipe2 from '../assets/recipe2.PNG'
import recipe3 from '../assets/recipe3.PNG'
import recipe4 from '../assets/recipe4.PNG'
import recipe5 from '../assets/recipe5.PNG'
import recipe6 from '../assets/recipe6.PNG'
import recipe7 from '../assets/recipe7.PNG'

import inote1 from '../assets/inote1.PNG'
import inote2 from '../assets/inote2.PNG'
import inote3 from '../assets/inote3.PNG'
import inote4 from '../assets/inote4.PNG'
import inote5 from '../assets/inote5.PNG'

import new1 from '../assets/new1.PNG'




const images =  {
  email,
  email2,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  js,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  jobin,

  social1,
  social2,
  social3,
  social4,
  social5,
  social6,

  shopping1,
  shopping2,
  shopping3,
  shopping4,
  shopping5,
  shopping6,
  shopping7,
  shopping8,
  shopping9,
  shopping10,
  shopping11,
  shopping12,
  shopping13,

  youtube1,
  youtube2,
  youtube3,
  youtube4,
  youtube5,
  youtube6,
  youtube7,
  youtube8,

  pizza1,
  pizza2,
  pizza3,
  pizza4,
  pizza5,
  pizza6,

  recipe1,
  recipe2,
  recipe3,
  recipe4,
  recipe5,
  recipe6,
  recipe7,

  inote1,
  inote2,
  inote3,
  inote4,
  inote5,

  new1,
};

export default images;